import React from "react";
import { Controller } from "react-hook-form";
import { Form, Collapse, Select, Switch } from "antd";
import moment from "moment";
import { formItemLayout } from "../../../utils/UI";

const { Panel } = Collapse;
const { Option } = Select;
moment.tz.setDefault("Etc/UTC");

const StatusUpdateElement = (props) => {
  const { control, errors } = props;

  return (
    <>
      <div className="container_ab">
        <Collapse defaultActiveKey={["10"]} expandIconPosition="end">
          <Panel header="Status Update" key="10">
            <Form.Item
              {...formItemLayout}
              label="Destinations"
              help={errors.job?.statusUpdate?.destinations?.message}
              required
              validateStatus={
                errors.job?.statusUpdate?.destinations ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="job.statusUpdate.destinations"
                render={({ field }) => (
                  <Select
                    showArrow
                    showSearch
                    mode="multiple"
                    {...field}
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) !== -1
                      );
                    }}
                    placeholder="Select Mapping Data Source"
                  >
                    <Option value="QMS">QMS</Option>
                  </Select>
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Notify NotFound Server Directory"
            >
              <Controller
                control={control}
                name="job.statusUpdate.notifyServerDirectoryNotFound"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="Notify Empty Server Directory"
            >
              <Controller
                control={control}
                name="job.statusUpdate.notifyServerDirectoryEmpty"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
            <Form.Item {...formItemLayout} label="Notify Unmapped Files">
              <Controller
                control={control}
                name="job.statusUpdate.notifyUnmappedFiles"
                render={({ field: { value, onChange } }) => (
                  <Switch checked={value} onChange={onChange} />
                )}
              />
            </Form.Item>
          </Panel>
        </Collapse>
      </div>
    </>
  );
};

export default StatusUpdateElement;
